<script setup lang="ts">
import { computed, defineProps } from 'vue'

const props = defineProps({
  sortMode: Boolean,
  archiveMode: Boolean,
})

const modelValue = defineModel()

const shouldShowModes = computed(() => props.sortMode || props.archiveMode)

function setMode(mode: string) {
  modelValue.value = mode
}
</script>

<template>
  <div v-if="shouldShowModes" class="flex relative text-2xs font-medium flex items-center voix-admin-bg-lightest voix-admin-text-dark rounded overflow-hidden">
    <span class="py-1.5  pl-3 pr-2.5">Mode:</span>
    <button
      class="py-1.5 px-2 border-r border-white/20 rounded-l"

      :class="{ 'voix-admin-bg-dark voix-admin-text-light': modelValue === 'normal', 'voix-admin-bg-light voix-admin-text-darkest': modelValue !== 'normal' }"
      @click="setMode('normal')"
    >
      <Icon name="heroicons:table-cells" class="w-4 h-4" />
    </button>
    <button
      v-if="props.sortMode"
      class="py-1.5 px-2 border-r border-white/20"
      :class="{
        'voix-admin-bg-dark voix-admin-text-light': modelValue === 'sort',
        'voix-admin-bg-light voix-admin-text-darkest': modelValue !== 'sort',
        'opacity-50': modelValue === 'archive',
      }"
      :disabled="modelValue === 'archive'"
      @click="setMode('sort')"
    >
      <Icon name="heroicons:arrows-up-down-20-solid" class="w-4 h-4" />
    </button>
    <button
      v-if="props.archiveMode"
      class="py-1.5 px-2"
      :class="{ 'voix-admin-bg-dark voix-admin-text-light': modelValue === 'archive', 'voix-admin-bg-light voix-admin-text-darkest': modelValue !== 'archive' }"
      @click="setMode('archive')"
    >
      <Icon name="heroicons:trash" class="w-4 h-4" />
    </button>
  </div>
</template>

<style scoped>

</style>
